<template>
  <div class="agreement-page">
    <div class="agreement-container">
      <div class="back-bar">
        <span class="back-link" @click="goBack">&lt; 返回</span>
      </div>
      <h1 class="agreement-title">博览财经资讯库个人信息保护政策</h1>
      <div class="meta-info">
        <p>生效日期：2026年07月</p>
        <p>运营主体：武汉博览财经信息技术股份有限公司</p>
      </div>

      <h3 class="section-title">引言</h3>
      <p>欢迎您使用博览财经资讯库网页端服务。本隐私政策依据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《电信和互联网用户个人信息保护规定》等法律法规制定，旨在向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您享有的相关权利。</p>
      <p>请您在注册、购买服务前仔细阅读本政策全部内容，特别是以加粗形式标注的与您权益重大相关的条款。您点击同意本政策或继续使用我们的服务，即视为您已充分理解并同意本政策全部内容。</p>

      <h3 class="section-title">一、我们如何收集和使用您的个人信息</h3>
      <p>我们遵循"合法、正当、必要、诚信"原则，仅收集为实现服务所必需的信息，具体场景如下：</p>
      <p class="sub-heading">（一）账号注册与登录</p>
      <p>为向您提供专属的资讯查阅服务、保障账号安全，您需要注册账号并完成登录：</p>
      <p>必要信息：您主动提供的手机号码或电子邮箱地址，用于账号验证、登录、找回密码及服务通知。</p>
      <p>可选信息：您可自愿补充昵称等基础信息，用于优化服务体验。</p>
      <p>若您拒绝提供必要信息，将无法注册账号并使用付费资讯服务。</p>
      <p class="sub-heading">（二）服务购买与支付</p>
      <p>当您购买网页端资讯服务时，我们需要处理您的订单与支付信息：</p>
      <p>我们会收集您的订单编号、购买套餐、支付金额、下单时间，用于生成订单、开通服务权限及后续对账。</p>
      <p>支付敏感信息说明：您通过微信、支付宝等第三方支付渠道完成付款时，支付过程由持牌支付机构直接处理。我们不收集、不存储您的银行卡号、支付密码、生物识别信息等敏感支付信息，仅获取支付结果通知（支付成功/失败状态）。</p>
      <p class="sub-heading">（三）发票开具</p>
      <p>如您申请开具发票，需您主动提供以下信息：</p>
      <p>个人抬头发票：开票抬头、接收邮箱；</p>
      <p>企业抬头发票：企业名称、纳税人识别号、接收邮箱。</p>
      <p>上述信息仅用于开具增值税电子普通发票并发送至您指定邮箱，发票开具完成后，我们将按财务档案管理规定留存相关信息。</p>
      <p class="sub-heading">（四）服务使用与优化</p>
      <p>为保障服务稳定运行、优化内容体验，我们会自动收集以下设备与使用日志信息：</p>
      <p>设备信息：设备型号、操作系统版本、浏览器类型、IP地址；</p>
      <p>服务日志：登录时间、访问页面、功能使用记录、异常报错信息；</p>
      <p>上述信息为匿名化、去标识化处理后的统计信息，无法单独识别到您的个人身份，主要用于系统故障排查、内容推荐优化及安全风控。</p>
      <p class="sub-heading">（五）客服与售后</p>
      <p>当您联系客服咨询、反馈问题时，我们会收集您的账号信息、沟通记录及您主动提供的相关信息，用于核实身份、处理您的诉求。</p>
      <p class="sub-heading">（六）合规与安全</p>
      <p>我们可能基于法律法规要求、网络安全保障、反欺诈风控等必要场景，依法处理您的相关信息。</p>
      <p>特别说明：</p>
      <p>本服务仅提供金融资讯整合查阅服务，不从事证券投资咨询、理财推荐等金融业务，我们不会主动收集您的证券账户信息、交易记录、资产状况、投资偏好等金融敏感信息。</p>
      <p>我们不会以任何方式要求您提供银行账户密码、支付密码、短信验证码等敏感信息，请您注意防范诈骗。</p>

      <h3 class="section-title">二、我们如何共享、转让、公开披露您的个人信息</h3>
      <p class="sub-heading">（一）信息共享</p>
      <p>我们不会向第三方出售、出租您的个人信息。仅在以下情形下，我们会向合作方共享必要信息，且会通过协议约束合作方的信息处理行为：</p>
      <p>1. 支付服务机构：为完成订单支付，向微信支付、支付宝等持牌支付机构共享订单编号、金额等必要交易信息；</p>
      <p>2. 发票服务机构：为开具电子发票，向税务机关授权的电子发票服务商共享您提供的开票信息；</p>
      <p>3. 云服务与技术服务商：为保障服务运行，向提供服务器、安全防护的技术服务商共享去标识化的日志信息；</p>
      <p>4. 监管与司法机关：根据法律法规规定，或应有权机关的合法要求，向监管部门、司法机关提供相关信息。</p>
      <p class="sub-heading">（二）信息转让</p>
      <p>如发生公司合并、分立、收购、资产转让等情形，您的个人信息可能随业务一并转移。我们会提前通知您，并要求受让方继续受本政策约束。</p>
      <p class="sub-heading">（三）公开披露</p>
      <p>除以下情形外，我们不会公开披露您的个人信息：</p>
      <p>1. 获得您的明确同意；</p>
      <p>2. 为维护公共利益，或根据法律法规、司法/行政机关的强制要求。</p>

      <h3 class="section-title">三、我们如何存储和保护您的个人信息</h3>
      <p>1. 存储地点：您的个人信息均存储于中华人民共和国境内的服务器中，我们不会向境外传输您的个人信息，法律法规另有规定或您单独同意的除外。</p>
      <p>2. 存储期限：服务存续期间，我们持续存储您的必要信息；账号注销后，我们将在法定期限届满后删除或匿名化处理您的个人信息；财务、税务等需依法留存的信息，将按相关法律法规规定的期限留存。</p>
      <p>3. 安全保护措施：我们采用行业通用的安全技术与管理制度保护您的信息，包括但不限于数据加密存储、访问权限控制、安全审计、员工保密培训等，防范信息泄露、篡改、丢失。</p>
      <p>4. 安全事件处置：如发生个人信息安全事件，我们将立即启动应急预案，采取补救措施，并按照法律法规要求向监管部门报告，同时通过站内信、邮件等方式通知您。</p>

      <h3 class="section-title">四、您对个人信息享有的权利</h3>
      <p>您对您的个人信息享有以下权利，您可通过客服渠道提交申请，我们将在15个工作日内响应处理：</p>
      <p>1. 知情权与查询权：您可查询您的账号信息、订单信息、开票记录等个人信息。</p>
      <p>2. 更正权：如您的信息有误，您可申请更正或补充。</p>
      <p>3. 删除权：在以下情形下，您可申请删除您的个人信息：</p>
      <p class="indent">（1）我们处理信息违反法律法规或约定；</p>
      <p class="indent">（2）您注销账号；</p>
      <p class="indent">（3）您撤回同意，且无其他合法处理依据。法律法规要求留存的信息除外。</p>
      <p>4. 注销账号：您可通过客服申请注销账号。账号注销后，我们将停止为您提供服务，并按规定删除相关信息。账号注销不可恢复，请您谨慎操作。</p>
      <p>5. 撤回同意：您可通过关闭系统权限、注销账号等方式撤回对个人信息处理的同意。撤回同意不影响撤回前基于同意开展的信息处理活动的效力。</p>
      <p>6. 获取副本：您可申请获取您的个人信息副本。</p>

      <h3 class="section-title">五、Cookie与同类技术的使用</h3>
      <p>为保障您顺畅登录、记住您的偏好设置，我们会在您的浏览器中存储Cookie数据。Cookie是小型文本文件，不会用于收集您的敏感信息。</p>
      <p>您可通过浏览器设置管理或删除Cookie，但关闭Cookie可能导致您无法正常登录或使用部分服务功能。</p>
      <p>我们会使用Cookie进行匿名化的访问统计，用于优化页面体验与服务质量。</p>

      <h3 class="section-title">六、未成年人保护</h3>
      <p>本服务主要面向成年金融市场参与者，我们不向未满18周岁的未成年人提供付费资讯服务。</p>
      <p>如您为未成年人，请在监护人的陪同下阅读本政策，并在监护人同意后使用本服务。监护人对未成年人信息的真实性、合法性承担责任。</p>
      <p>如我们发现收集了未成年人的个人信息，将尽快采取删除措施。</p>

      <h3 class="section-title">七、政策的更新</h3>
      <p>我们可能根据法律法规更新、业务调整等情况修订本隐私政策。修订后的政策将在本页面公示，公示期不少于7日。</p>
      <p>政策更新后，您继续使用我们的服务，即视为您同意修订后的政策。</p>
      <p>对于重大变更（如信息收集目的、共享范围、您的核心权利等变更），我们会通过网站公告、站内信等更显著的方式通知您。</p>

      <h3 class="section-title">八、联系我们</h3>
      <p>如您对本隐私政策有任何疑问、意见或投诉，或需要行使个人信息相关权利，可通过以下方式联系我们：</p>
      <p>客服电话：13396040230（赵女士微信同号）</p>
      <p>客服邮箱：bolancaijing@bolanjr.com</p>
      <p>公司地址：湖北省武汉市东湖新技术开发区光谷大道光谷芯中心文华楼3单元605</p>
      <p>我们将在收到您的诉求后15个工作日内进行处理与回复。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.agreement-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 40px;
}
.agreement-container {
  width: 1200px;
  max-width: 1200px;
  margin: 70px auto 0;
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 40px 60px 60px;
  box-sizing: border-box;
}
.back-bar {
  margin-bottom: 20px;
}
.back-link {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}
.back-link:hover {
  color: #66b1ff;
}
.agreement-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin: 10px 0 16px;
  line-height: 1.5;
}
.meta-info {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 1px dashed #e4e7ed;
}
.meta-info p {
  font-size: 14px;
  color: #909399;
  line-height: 1.8;
  margin: 2px 0;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 28px 0 14px;
  padding-left: 10px;
  border-left: 4px solid #c0a36c;
}
.agreement-container p {
  font-size: 15px;
  line-height: 1.9;
  color: #333333;
  margin: 8px 0;
  text-align: justify;
}
.agreement-container p.sub-heading {
  font-weight: 600;
  color: #303133;
  margin-top: 14px;
}
.agreement-container p.indent {
  padding-left: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue